import styled from 'styled-components';
import FAIcon from '../components/antd/Icons/FAIcon';

const table = {
  newFlag: 'isNew',
  deletedFlag: 'isDeleted',
  deleteTimeout: 1000,
  rowClassName: function (record: Record<string, unknown>) {
    if (record[table.deletedFlag]) {
      return 'deleted-row';
    }
    if (record[table.newFlag]) {
      return 'added-row';
    }
  }
};

const Animations = {
  table
};

export default Animations;

export const DuotoneAnimatedIcon = styled(FAIcon)`
  @keyframes opacity {
    from {
      opacity: 0.4;
    }
    to {
      opacity: 1;
    }
  }

  .fa-primary {
    animation: opacity ease-in infinite alternate 2s;
  }

  .fa-secondary {
    animation: opacity ease-in infinite alternate-reverse 2s;
  }
`;

export const SpringMotionDivProps = {
  layout: true,
  transition: {
    type: 'spring',
    damping: 25,
    stiffness: 300,
  },
  initial: { y: 10, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -10, opacity: 0 },
}
